module.exports = __webpack_public_path__ + "static/media/student1.20306aa7.png";